<template>
    <div class="SummaryPanel">
        <div class="SummaryPanel-holder" :class="{'is-opened': opened}">
            <h2 class="SummaryPanel-title">Kalkulace</h2>
            <div class="SummaryPanel-container">
                <div class="SummaryPanel-items">
                    <table>
                        <template v-for="item of result">
                            <tr v-if="item.price">
                                <th>{{item.label}}
                                    <span class="mainValue" v-if="true||item.mainValue">{{item.mainValue}}</span>
                                    <ul class="parts" v-if="item.parts">
                                        <li v-for="(part) in item.parts">
                                            {{part}}
                                        </li>
                                    </ul>
                                    <div class="parts-price">
                                        <small v-if="item.originPrice">{{ formatPrice(item.originPrice) }}</small>
                                        {{ formatPrice(item.price, item.isPriceFrom) }}
                                        <span v-if="item.frequency">{{item.frequency}}x ročně</span>
                                    </div>
                                </th>
                            </tr>
                        </template>
                        <tr class="SummaryPanel-gift" v-if="gift">
                            <th>
                                <span class="SummaryPanel-giftText">
                                    <strong>Dárek: </strong>
                                    <span>{{ gift.title }}</span>
                                </span>
                                <span class="SummaryPanel-giftPrice">zdarma</span>
                            </th>
                        </tr>
                    </table>
                </div>
                <div class="SummaryPanel-totalPercentage" v-if="total.totalPriceBase">
                    <p>Celková zakladní cena:</p>
                    <div>{{ formatPrice(total.totalPriceBase) }}</div>
                </div>
                <div class="SummaryPanel-totalPercentage" v-if="total.totalPriceAddition">
                    <p>
                        <template v-if="total.totalPriceAddition < 0">Sleva z celkové ceny</template>
                        <template v-else>Navýšení z celkové ceny</template>
                        ({{total.totalPriceAdditionPercentage}}%):
                    </p>
                    <div>{{ formatPrice(total.totalPriceAddition) }}</div>
                </div>
                <template v-if="configuration.discount.success">
                    <div class="SummaryPanel-discount">
                        <p><strong>Slevový kód<span v-if="configuration.discount.discount.discount"> (- {{ configuration.discount.discount.discount }} %)</span>:</strong> </p>
                        <div class="DiscountInfo-wrapper">
                            <div class="Discount-code">
                                {{ configuration.discount.discount.title }}
                            </div>
                            <div v-if="configuration.discount.discount.discount" class="SummaryPanel-nowrap">- {{ formatPrice(total.amountSaved) }}</div>
                            <div v-if="configuration.discount.discount.fixedDiscount" class="SummaryPanel-nowrap">- {{ formatPrice(configuration.discount.discount.fixedDiscount) }}</div>
                        </div>
                    </div>
                </template>
                <div class="SummaryPanel-totalPercentage" v-if="total.totalPrice" v-for="(modifier, index) in total.modifiers" :key="index">
                    <p>{{modifier.title}} ({{modifier.percentage}}%):</p>
                    <div>{{formatPrice(modifier.price)}}</div>
                </div>
            </div>

            <div class="SummaryPanel-total">
                <div class="SummaryPanel-price">
                    <p>Cena:</p>
                </div>
                <div>
                    <template v-if="total.totalPrice">
                        <span class="SummaryPanel-noTaxPrice">{{ formatPrice(total.totalPriceWithoutVat) }} bez DPH</span>
                        <span class="SummaryPanel-tax">+ {{ configuration.currentVatLevel }} % DPH - {{ formatPrice(total.totalPriceWithCurrentVat - total.totalPriceWithoutVat) }}</span>
                        <span>{{ formatPrice(total.totalPriceWithCurrentVat) }} s DPH</span>
                    </template>
                    <template v-else>0 Kč</template>
                    <span v-if="false">+&nbsp;individuální cenová nabídka</span>
                </div>
            </div>
        </div>
        <div class="SummaryPanel-opener" :class="{'is-opened': opened}" @click="toggle">
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"></path></svg>
        </div>
    </div>
</template>

<script>
import {inject, ref} from 'vue';
import {formatPrice} from "../utils/utils";

export default {
    props: {
        configuration: Object,
        result: Object,
        total: Object,
        gift: Object,
        stepsLength: Number,
        currentStep: Number
    },
    setup () {
        const opened = ref(false);

        const toggle = () => {
            opened.value = !opened.value;
        }

        return {
            opened,
            toggle,
            formatPrice
        }
    }
}
</script>

<style lang="scss" scoped>
.SummaryPanel {
    border-bottom: 2px solid var(--colorBrand);
    position: relative;
    @media(max-width: 980px) {
        border-bottom: none;
    }

    &-price {
        align-self: flex-start;
    }

    &-gift {

        th{
            width: 100%;
            display: inline-flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }
    }


    &-holder {
        background: var(--colorBrandLighten);
        border-top: 2px solid var(--colorBrand);
        box-shadow: inset 0 -4px 0 #fff;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        transition: all .25s ease-in-out;
        @media(max-width: 980px) {
            border-top: none;
            max-height: 0;
            box-shadow: none;
        }

        &.is-opened {
            @media(max-width: 980px) {
                border-top: 2px solid var(--colorBrand);
                max-height: 100vh;
                padding-bottom: 2em;
            }
        }
    }

    &-opener {
        background: var(--colorBrand);
        color: #fff;
        position: absolute;
        bottom: 0;
        right: 1em;
        padding: .5em .7em .1em;
        display: none;
        @media(max-width: 980px) {
            display: block;
        }

        svg {
            transition: all .25s ease-in-out;
        }

        &.is-opened {
            svg {
                transform: rotate(-180deg);
            }
        }
    }

    &-title {
        font-size: var(--textXl);
        font-weight: 700;
        padding: .8em .8em 0;
        margin: 0;
    }

    &-container {
        overflow: auto;
        max-height: calc(100vh - 19.8em);
        padding: 1.5em;
    }

    &-items {
        table {
            border-collapse: collapse;
            width: 100%;
            margin-bottom: 1.5em;

            tr {
                small {
                    display: block;
                    font-size: 0.85em;
                    text-decoration: line-through;
                    color: #848484;
                }

                th,td {
                    border-top: 1px solid #d8d8d3;
                    padding: 20px 0;
                    &.is-sub {
                        border: none;
                        padding-top: 0;
                        font-size: .8em;
                    }
                }
                th {
                    text-align: left;
                    font-weight: 400;
                    padding-right: 10px;

                    span {
                        // white-space: nowrap;
                        &:not(.SummaryPanel-giftText, .SummaryPanel-giftPrice) {
                            color: #908d7e;
                            font-size: .85em;
                            display: inline-block;
                        }
                    }
                }
                td {
                    text-align: right;

                    span {
                        display: block;
                        font-size: .8em;
                    }
                }

                &:last-child {
                    th, td {
                        border-bottom: 1px solid #d8d8d3;
                    }
                }

                &:first-child {
                    th, td {
                        border-top: none;
                        padding-top: 0;
                    }
                }
            }
        }
    }

    &-totalPercentage,
    &-discount {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 400;
        margin-bottom: .5em;

        .DiscountInfo-wrapper{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            .Discount-code{
                font-weight: 400;
                text-align: left;
                color: #908d7e;
                font-size: .85em;
            }
        }

        &:last-child {
            margin-bottom: 0;
        }

        p {
            margin: 0;
            margin-right: 10px;
            font-size: .9em;
        }

        div {
            text-align: right;
            font-weight: 700;
            font-size: 1em;
        }
    }

    &-discount {
        flex-wrap: wrap;

        p {
            width: 100%;
        }
    }

    &-total {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 600;
        padding: 1em 1.5em;
        border-top: 1px solid #d8d8d3;

        p {
            margin: 0;
            white-space: nowrap;
            margin-right: 10px;
        }

        div {
            font-weight: 700;
            font-size: 1.125rem;
            margin-top: auto;

            &:not(:first-of-type) {
                text-align: right;
            }

            span {
                display: block;
                font-size: 1.125rem;

                &.SummaryPanel-tax, &.SummaryPanel-noTaxPrice{
                    font-weight: 400;
                }

                &.SummaryPanel-tax{
                    font-size: .75rem;
                }

                &.SummaryPanel-noTaxPrice{
                    font-size: 1rem;
                }
            }
        }
    }

    &-nowrap {
        white-space: nowrap;
    }

    li {
        list-style: inside;
    }

    .parts-price{
        text-align: right;
    }
}

.parts {

    li {
        font-size:.85em;
        color: #908d7e;
    }
}
</style>